import React from 'react';
import gql from 'graphql-tag';
import { toast } from 'react-toastify';
import uuidv4 from 'uuid/v4';

import client from '../../../utils/apolloClient';

const searchCmsAclsQuery = gql`
  query searchCmsAclsQuery($input: SearchInput) {
    search_cms_acls(input: $input) {
      acls {
        acl_id
        name
        description
        status
        api_actions {
          api_action_id
          name
          description
        }
        page_actions {
          page_action_id
          name
          status
          description
          api_actions {
            api_action_id
            name
            description
          }
        }
        error {
          code
          description
        }
      }
      total_pages
      total_size
    }
  }
`;

const fetchApiActions = async ({ aclId, name, status, from, size, sort }) => {
  const input = { from, size, sort };

  input.filter = {};

  input.filter.cms_acl_filter = {};

  if (aclId) {
    input.filter.cms_acl_filter.acl_id = aclId;
  }

  if (name) {
    input.filter.cms_acl_filter.name = name;
  }

  if (status) {
    input.filter.cms_acl_filter.status = status;
  }

  try {
    const data = await client.clientPrivate.query({
      client: client.clientPrivate,
      query: searchCmsAclsQuery,
      variables: { input },
      fetchPolicy: 'network-only',
    });
    if (data && data.data && data.data.search_cms_acls) {
      return data.data.search_cms_acls;
    }
    return null;
  } catch (error) {
    throw error;
  }
};

export const useCmsData = ({ aclId, name, status, from, size, sort }) => {
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(null);
  const [totalElements, setTotalElements] = React.useState(null);
  const [cmsData, setCmsData] = React.useState(null);
  const [reload, setReload] = React.useState(uuidv4());

  React.useEffect(() => {
    let loadData = true;
    const fetchData = async () => {
      setLoading(true);
      try {
        const data = await fetchApiActions({
          aclId,
          name,
          status,
          from,
          size,
          sort,
        });
        if (loadData) {
          setPageCount(data.total_pages);
          setTotalElements(data.total_size);
          setCmsData(data?.acls ?? []);
          setLoading(false);
        }
      } catch (error) {
        toast.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();

    return () => {
      loadData = false;
    };
  }, [aclId, name, status, from, size, sort, reload]);

  return {
    loading,
    pageCount,
    totalElements,
    cmsData,
    refetch: () => setReload(uuidv4()),
  };
};

export default {};
